module.exports = __webpack_public_path__ + "static/media/team-irfan.faabf489.png";